import { getHostbaseUrl } from '@core/tools';
import { IPageParam } from '../../types/common';
import { IAddAgentProfitConfig, IAgentProfitConfigDetail, IAgentProfitItem } from '../../types/crowd-source/agent-share-profit';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';

const hostUrl = getHostbaseUrl();

/**
 * 众包灵工 - 特代授权 - 分页查询
 */
export async function queryAgentProfitPage(param: IPageParam, isBroker: boolean = false) {
  let data = [] as IAgentProfitItem[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IPageParam;

  try {
    const { code, context, message } = await Http.post<{ data: IAgentProfitItem[]; total: number }>(`${hostUrl}/side/agent/profit/page${isBroker ? '?productType=1' : ''}`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IAgentProfitItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 众包灵工 - 特代授权 - 详情
 */
export async function queryAgentProfitDetail(id: number) {
  let data = {} as IAgentProfitConfigDetail;

  try {
    const { code, context, message } = await Http.post<IAgentProfitConfigDetail>(`${hostUrl}/side/agent/profit/detail`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IAgentProfitConfigDetail;

      data = items || {} as IAgentProfitConfigDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 众包灵工 - 特代授权 - 配置
 */
export async function agentProfitConfig(params: IAddAgentProfitConfig, isBroker: boolean = false) {
  try {
    const { code, message } = await Http.post<IAgentProfitConfigDetail>(`${hostUrl}/side/agent/profit/config${isBroker ? '-match-product' : ''}`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}